module.exports = __webpack_public_path__ + "static/media/technology-forest.1175102d.md";